import { rootStyle } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
export var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1yf4tyt-0"
})(["", ";position:relative;inline-size:100%;display:flex;align-items:center;"], rootStyle());